import { createReducer } from "@reduxjs/toolkit";
import {
  getLivestreamMessages,
  getLivestreamMessagesFailure,
  getLivestreamMessagesSuccess,
} from "@redux/livestreamMessages/actions";

const initialState = {
  allMessages: [],
  messagesById: {},
  isLoading: false,
  error: null,
};

export default createReducer(initialState, (builder) => {
  builder
    //getLivestreamMessages
    .addCase(getLivestreamMessages.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getLivestreamMessagesSuccess.type, (state, { payload }) => {
      const { allMessages, messagesById, totalCount, isNextPage, nextOffset } =
        payload;
      return {
        ...state,
        allMessages: isNextPage
          ? [...new Set([...state.allMessages, ...allMessages])]
          : [...allMessages],
        totalCount,
        nextOffset,
        messagesById: { ...state.messagesById, ...messagesById },
        isLoading: false,
      };
    })
    .addCase(getLivestreamMessagesFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }));
});
